import React from 'react'

import {
  FeaturedCarouselType,
  SortOptionType,
  SortOrder,
} from '~/app/common/enums'
import { useTranslation } from '~/app/i18n/client'
import { useItems } from '../hooks/use-items'
import { FeaturedCarousel } from './featured-carousel'

const FeaturedProducts: React.FC<{ content?: any }> = ({ content }) => {
  const { loading, items } = useItems(
    {
      isFeatured: true,
      sort: { by: SortOptionType.CreatedDate, order: SortOrder.Descending },
    },
    1,
    content?.pageSize ? Number(content?.pageSize) : undefined,
  )

  const { t: translate } = useTranslation()

  return (
    <FeaturedCarousel
      type={FeaturedCarouselType.Product}
      title={translate('featuredProducts')}
      helperText={translate('featuredProductsHelperText')}
      items={items}
      loading={loading}
    />
  )
}

export { FeaturedProducts }
